import { ErrorTypes } from '@wix/form-validator';

import type { PossibleValues } from '../../../ui/form/types';

export const validateBirthdate = ({
  value,
  target,
}: {
  value?: PossibleValues;
  target: string;
}) => {
  if (!value) {
    return undefined;
  }

  const date = new Date(value as string);

  if (date.getFullYear() < 1900) {
    return {
      errorPath: target,
      errorType: ErrorTypes.MIN_VALUE_ERROR,
      errorMessage: '',
    };
  }

  if (date.getTime() > Date.now()) {
    return {
      errorPath: target,
      errorType: ErrorTypes.MAX_VALUE_ERROR,
      errorMessage: '',
    };
  }

  return undefined;
};
